import get from "lodash/get";
import mapValues from "lodash/mapValues";
import validate from "validate.js";
import { isNil } from "../../utils/operations";
import { constraints } from "../../utils/validation";

export const contactValidationConstraints = {
    "phoneNumber.phoneNumber": {
        ...constraints.number,
    },
    "address.zipCode.zipCode": {
        ...constraints.id,
    },
};

const validateAddress = (addr) => {
    if (!addr) return {};

    const address = addr.address1;
    const city = addr?.city?.city;
    const state = addr?.city?.state?.stateCode;
    const zipCode = addr?.zipCode?.zipCode;

    const hasAnyValue = [address, city, state, zipCode].some((val) => !isNil(val) && val !== "");

    if (!hasAnyValue) return {};

    const errors = {};
    if (isNil(address) || address === "") errors["address.address1"] = "Required";
    if (isNil(city) || city === "") errors["address.city.city"] = "Required";
    if (isNil(state) || state === "") errors["address.city.state.stateCode"] = "Required";
    if (isNil(zipCode) || zipCode === "") errors["address.zipCode.zipCode"] = "Required";

    return errors;
};

const validateContact = (contact) => {
    let errors = {
        ...mapValues(validate(contact, contactValidationConstraints, { fullMessages: false }), (error) => {
            return error[0];
        }),
        ...validateAddress(get(contact, "address")),
    };
    return errors;
};

export default {
    validateContact,
};
